import { AddSelectedCallerIdAction, CallerIdState } from '../types';

export const addSelectedCallerId = (state: CallerIdState, value: AddSelectedCallerIdAction) => ({
  ...state,
  lastSelectedCallerId: value.payload.id,
});
